<div class="tituloDialog">{{ titulo }}</div>
<div mat-dialog-content>
  <section>
    <form
      class="formContainer"
      [formGroup]="formulario"
      (ngSubmit)="onSubmit()"
    >
      <div class="rowOutline" *ngIf="cotacaoOuEndosso !== null && validaTipo()">
        <mat-label
          ><strong>{{ cotacaoOuEndosso }} nº </strong>{{ entidade.id }} -
          {{ dataCriacao | date : "dd/MM/yyyy" }}
        </mat-label>
      </div>
      <div class="rowOutline" *ngIf="validaTipo()">
        <mat-label><strong>Cooperado: </strong>{{ getCliente() }}</mat-label>
      </div>
      <div class="row">
        <mat-checkbox formControlName="cancelaTodosCupons" (change)="$event.checked ? formulario.get('cancelarParcialmente')?.setValue(false) : null" *ngIf="data.tipo === 'CUPOM' && data.row">Cancelar todos os cupons.</mat-checkbox>
      </div>
        <div class="row" *ngIf="data.tipo === 'CUPOM' && data.row">
          <mat-checkbox formControlName="cancelarParcialmente" (change)="$event.checked ? formulario.get('cancelaTodosCupons')?.setValue(false) : null">Cancelar parcialmente</mat-checkbox>
          <mat-form-field appearance="outline" *ngIf="formulario.get('cancelarParcialmente')?.value" class="w10">
           <mat-label>Quantidade</mat-label>
            <input class="right"
              matInput
              type="number"
              min="1"
              [max]="data.row.totalCupons"
              #inputQuantidade
              formControlName="qtdeCupons"
            />
          </mat-form-field>
        </div>
      <br />
      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Motivo</mat-label>
          <textarea
            class="textArea"
            matInput
            #inputDescricao
            formControlName="motivoCancelamento"
            cdkAutosizeMinRows="30"
            cdkAutosizeMaxRows="30"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="item-right">
        <button
          mat-button
          class="btnOK mat-elevation-z8"
          [disabled]="formulario.invalid || formulario.pristine || (data.tipo === 'CUPOM' && !formulario.get('cancelaTodosCupons')?.value && (!formulario.get('cancelarParcialmente')?.value || (formulario.get('qtdeCupons')?.value || 0) <= 0))"
          type="submit"
        >
          Salvar
        </button>
        <button
          mat-button
          class="btnCancel mat-elevation-z8"
          type="button"
          (click)="cancelClick()"
        >
          Cancelar
        </button>
      </div>
    </form>
  </section>
</div>
